import { hashKey, useQuery } from '@tanstack/react-query';

import { IUsersCriteria, SortDirection, User } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const defaultUsersCriteria: IUsersCriteria = {
  filters: {},
  pagination: { page: 1, size: 10 },
  sorting: { field: 'email', direction: SortDirection.ASC },
};

export const useDeclarantUsers = (criteria: IUsersCriteria = defaultUsersCriteria) => {
  return useQuery({
    queryKey: ['users-list', hashKey([criteria])],
    queryFn: async (): Promise<{ data: { users: User[]; totalItems: number } }> => {
      try {
        const result = await apiClient.user.retrieveDeclarantUsers.mutation({ body: { criteria } });

        if (result.status !== 200) throw result.body;
        return {
          data: {
            users: (result.body.data?.users as User[]) ?? [],
            totalItems: result.body.data?.totalItems ?? 0,
          },
        };
      } catch (error) {
        showErrorToast(error, 'Failed to fetch users list');
        return { data: { users: [], totalItems: 0 } };
      }
    },
  });
};
